import React from 'react';

const DOORDASH_URL = 'https://www.doordash.com/store/desi-bites-centerton-31061357';
const PHONE_DISPLAY = '(479) 412-9916';
const PHONE_HREF = 'tel:+14794129916';

/**
 * Sticky bottom "Order Online" bar for the customer menu.
 *
 * Points to DoorDash for both pickup & delivery while the native Square
 * ordering flow stays staff-only. When native online ordering launches to the
 * public, switch the Pickup button's href to "/order".
 */
const OrderBar = () => (
  <>
    <style>{`
      .fm-orderbar { position: fixed; left: 0; right: 0; bottom: 0; z-index: 120;
        background: rgba(15,23,42,0.96); backdrop-filter: blur(10px);
        border-top: 1px solid rgba(245,158,11,0.35);
        box-shadow: 0 -6px 24px rgba(0,0,0,0.35);
        padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px)); }
      .fm-orderbar__inner { max-width: 900px; margin: 0 auto; display: flex; align-items: center;
        gap: 12px; flex-wrap: wrap; justify-content: center; }
      .fm-orderbar__label { color: #fff; font-weight: 700; font-size: 15px; }
      .fm-orderbar__btns { display: flex; gap: 10px; flex: 1; justify-content: center; min-width: 220px; }
      .fm-orderbar__btn { flex: 1; max-width: 220px; text-align: center; text-decoration: none;
        font-weight: 800; font-size: 15px; padding: 12px 16px; border-radius: 999px;
        transition: transform .12s ease, box-shadow .12s ease; white-space: nowrap; }
      .fm-orderbar__btn:hover { transform: translateY(-1px); }
      .fm-orderbar__btn--pickup { background: #f59e0b; color: #1a1206;
        box-shadow: 0 4px 14px rgba(245,158,11,0.4); }
      .fm-orderbar__btn--delivery { background: #ef4444; color: #fff;
        box-shadow: 0 4px 14px rgba(239,68,68,0.4); }
      .fm-orderbar__call { color: #cbd5e1; font-size: 13px; text-decoration: none; white-space: nowrap; }
      .fm-orderbar__call:hover { color: #f59e0b; }
      @media (max-width: 560px) {
        .fm-orderbar__label { display: none; }
        .fm-orderbar__call { flex-basis: 100%; text-align: center; }
      }
    `}</style>
    <div className="fm-orderbar" role="region" aria-label="Order online">
      <div className="fm-orderbar__inner">
        <span className="fm-orderbar__label">Ready to eat?</span>
        <div className="fm-orderbar__btns">
          <a className="fm-orderbar__btn fm-orderbar__btn--pickup" href={DOORDASH_URL} target="_blank" rel="noopener noreferrer">
            🛍️ Order Pickup
          </a>
          <a className="fm-orderbar__btn fm-orderbar__btn--delivery" href={DOORDASH_URL} target="_blank" rel="noopener noreferrer">
            🚗 Order Delivery
          </a>
        </div>
        <a className="fm-orderbar__call" href={PHONE_HREF}>or call {PHONE_DISPLAY}</a>
      </div>
    </div>
  </>
);

export default OrderBar;
